import { ROUTES } from '@client/pages/routes';
import httpRequest from './httpRequest';
import {
  BASE_ADMIN_PATH,
  getBaseRequestConfig,
  LOCAL_BASE_PATH,
} from './baseRequestConfig';

export function fetchAllEpisodes() {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}${ROUTES.episodes}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
  });

  return httpRequest(requestConfig);
}

export function getEpisodesPage() {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}${ROUTES.episodes}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
  });

  return httpRequest(requestConfig);
}

export function getSingleEpisode(episodeId, seriesId) {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/series/${seriesId}/episodes/${episodeId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function getAdminEpisode(episodeId, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/episodes/${episodeId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function getAdminEpisodes(accessToken, seriesId) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/series/${seriesId}/episodes`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function deleteEpisode(episodeId, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/episodes/${episodeId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'DELETE',
  });

  return httpRequest(requestConfig);
}

export function postEpisode(body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/episodes`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: body,
  });

  return httpRequest(requestConfig);
}

export function putEpisode(episodeId, body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/episodes/${episodeId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: body,
  });

  return httpRequest(requestConfig);
}

export function getAllEpisodesPageConfig(ignore, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/episodes/page`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function putAllEpisodesPageConfig(ignore, body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/episodes/page`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: body,
  });

  return httpRequest(requestConfig);
}
